module.exports = __webpack_public_path__ + "static/img/1_2_1.03b4d3de.jpg";